<app-header *ngIf="!embedded" [forceLightBackground]="true"></app-header>
<div
  class="add-policy-home"
  [class.add-policy-home--provider]="!isOrgAdminRoute"
  [class.add-policy-home--embedded]="embedded"
>
  <div class="add-policy-home--layout" [class.add-policy-home--layout-embedded]="embedded">
    <app-org-admin-sidebar *ngIf="!embedded && isOrgAdminRoute" class="add-policy-home--sidebar"></app-org-admin-sidebar>
    <app-provider-sidebar *ngIf="!embedded && !isOrgAdminRoute" class="add-policy-home--sidebar"></app-provider-sidebar>

    <div class="add-policy-home--content" [class.add-policy-home--content-embedded]="embedded">
      <div *ngIf="!embedded" class="add-policy-home--body">
        <app-page-header [showDivider]="false"></app-page-header>
      </div>
      <hr *ngIf="!embedded" class="add-policy-home--title-divider" aria-hidden="true" />
      <div class="add-policy-home--body">
        <div class="add-policy-home__page-container">
          <form class="policy-wizard" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
            <div class="policy-wizard__stepper" role="tablist" aria-label="Add policy steps">
              <ng-container *ngFor="let step of wizardSteps; let i = index">
                <div
                  class="policy-wizard__step"
                  role="tab"
                  tabindex="0"
                  [class.policy-wizard__step--active]="isWizardStepActive(i)"
                  [class.policy-wizard__step--completed]="isWizardStepCompleted(i)"
                  [class.policy-wizard__step--clickable]="isWizardStepClickable(i)"
                  [attr.aria-selected]="isWizardStepActive(i)"
                  (click)="onWizardStepClick(i)"
                  (keydown.enter)="onWizardStepClick(i)"
                  (keydown.space)="$event.preventDefault(); onWizardStepClick(i)"
                >
                  <div class="policy-wizard__step-circle">
                    <svg
                      *ngIf="isWizardStepCompleted(i) && !isWizardStepActive(i)"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M20 6L9 17L4 12"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span *ngIf="!isWizardStepCompleted(i) || isWizardStepActive(i)">{{ i + 1 }}</span>
                  </div>
                  <span class="policy-wizard__step-label">{{ step.label }}</span>
                  <div
                    *ngIf="i < wizardSteps.length - 1"
                    class="policy-wizard__step-connector"
                    [class.policy-wizard__step-connector--completed]="isWizardConnectorCompleted(i)"
                    aria-hidden="true"
                  ></div>
                </div>
              </ng-container>
            </div>

            <div class="policy-wizard__main">
              <div class="policy-wizard__panel">
              <!-- Step 1 -->
              <div class="policy-wizard__step-panel add-policy-home__section--org-role" *ngIf="currentStep === 1">
                <div class="policy-wizard__step-intro">
                  <h2 class="policy-wizard__step-title">Policy scope</h2>
                  <p class="policy-wizard__step-desc">
                    Choose whether this policy applies to a group or an individual user.
                  </p>
                </div>

                <p class="add-policy-home__field-label add-policy-home__field-label--block">
                  Scope type<span class="add-policy-home__required" aria-hidden="true">*</span>
                </p>
                <div class="add-policy-home__scope-picker" role="radiogroup" aria-label="Policy scope type">
                  <button
                    type="button"
                    class="add-policy-home__scope-choice"
                    [class.add-policy-home__scope-choice--selected]="isGroupScope"
                    (click)="onScopeTypeChange('group')"
                    role="radio"
                    [attr.aria-checked]="isGroupScope"
                  >
                    <span class="add-policy-home__scope-choice-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke-linecap="round" stroke-linejoin="round" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                    <span class="add-policy-home__scope-choice-text">
                      <span class="add-policy-home__scope-choice-title">Group</span>
                      <span class="add-policy-home__scope-choice-desc">Organisation and role based access</span>
                    </span>
                    <span class="add-policy-home__scope-choice-radio" aria-hidden="true"></span>
                  </button>
                  <button
                    type="button"
                    class="add-policy-home__scope-choice"
                    [class.add-policy-home__scope-choice--selected]="isIndividualScope"
                    (click)="onScopeTypeChange('individual')"
                    role="radio"
                    [attr.aria-checked]="isIndividualScope"
                  >
                    <span class="add-policy-home__scope-choice-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke-linecap="round" stroke-linejoin="round" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                    </span>
                    <span class="add-policy-home__scope-choice-text">
                      <span class="add-policy-home__scope-choice-title">Individual</span>
                      <span class="add-policy-home__scope-choice-desc">Target a specific user by email</span>
                    </span>
                    <span class="add-policy-home__scope-choice-radio" aria-hidden="true"></span>
                  </button>
                </div>

                <div class="add-policy-home__grid-2 add-policy-home__grid-2--scope-fields">
                  <div class="add-policy-home__field" *ngIf="isGroupScope">
                    <label class="add-policy-home__label" for="add-policy-organisation">
                      Organisation<span class="add-policy-home__required" aria-hidden="true">*</span>
                    </label>
                    <app-multiselect
                      id="add-policy-organisation"
                      [ngModel]="organisationSelection"
                      (ngModelChange)="onOrganisationMultiselectChange($event)"
                      [ngModelOptions]="{ standalone: true }"
                      [options]="organisationOptions"
                      optionLabel="label"
                      placeholder="Choose organisation"
                      [filter]="true"
                      [maxSelected]="1"
                      [disabled]="organisationsLoading"
                      display="chip"
                      styleClass="add-policy-home__multiselect add-policy-home__multiselect--stack-top"
                      (onTriggerMousedown)="onMultiselectTriggerMousedown($event)"
                      (onOpen)="onMultiselectOpen()"
                    ></app-multiselect>
                  </div>

                  <div class="add-policy-home__field" *ngIf="isGroupScope">
                    <label class="add-policy-home__label" for="add-policy-role">
                      Role<span class="add-policy-home__required" aria-hidden="true">*</span>
                    </label>
                    <app-multiselect
                      id="add-policy-role"
                      [ngModel]="roleSelection"
                      (ngModelChange)="onRoleMultiselectChange($event)"
                      [ngModelOptions]="{ standalone: true }"
                      [options]="roleOptions"
                      optionLabel="label"
                      placeholder="Choose role"
                      display="chip"
                      styleClass="add-policy-home__multiselect add-policy-home__multiselect--stack-top"
                      (onTriggerMousedown)="onMultiselectTriggerMousedown($event)"
                      (onOpen)="onMultiselectOpen()"
                    ></app-multiselect>
                  </div>

                  <div class="add-policy-home__field add-policy-home__field--individual-email" *ngIf="isIndividualScope">
                    <label class="add-policy-home__label" for="add-policy-individual-email">
                      Email Id<span class="add-policy-home__required" aria-hidden="true">*</span>
                    </label>
                    <div class="add-policy-home__email-input-wrap">
                      <input
                        id="add-policy-individual-email"
                        type="email"
                        class="add-policy-home__input"
                        [class.add-policy-home__input--with-actions]="showValidateIndividualEmailButton"
                        [class.add-policy-home__input--invalid]="showIndividualEmailFieldError"
                        formControlName="individualEmail"
                        (input)="onIndividualEmailInput()"
                        placeholder="Enter email address"
                        autocomplete="email"
                        [attr.aria-invalid]="showIndividualEmailFieldError"
                      />
                      <div class="add-policy-home__input-actions" *ngIf="showValidateIndividualEmailButton">
                        <button
                          type="button"
                          class="add-policy-home__input-clear"
                          (click)="onClearIndividualEmail()"
                          aria-label="Clear email"
                          title="Clear"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path
                              d="M18 6L6 18M6 6L18 18"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="add-policy-home__input-action"
                          (click)="onValidateIndividualEmail()"
                          [disabled]="isValidateIndividualEmailButtonDisabled"
                          aria-label="Validate email"
                          title="Validate email"
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <ng-container *ngIf="isIndividualEmailVerified; else pendingValidateIcon">
                              <path
                                d="M20 6L9 17L4 12"
                                stroke="currentColor"
                                stroke-width="2.25"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </ng-container>
                            <ng-template #pendingValidateIcon>
                              <circle
                                cx="11"
                                cy="11"
                                r="6.5"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M16 16L20 20"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                              />
                            </ng-template>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <small class="add-policy-home__input-hint" *ngIf="individualEmailLookupLoading">
                      Verifying email...
                    </small>
                    <small
                      class="add-policy-home__input-error"
                      *ngIf="showInvalidEmailFormatMessage"
                      role="alert"
                    >
                      Enter a valid email address.
                    </small>
                    <small
                      class="add-policy-home__input-error"
                      *ngIf="showInvalidEmailMessage"
                      role="alert"
                    >
                      No user found for this email
                    </small>
                  </div>
                </div>

              </div>

              <!-- Step 2 -->
              <div class="policy-wizard__step-panel add-policy-home__section--asset" *ngIf="currentStep === 2">
                <div class="policy-wizard__step-intro">
                  <h2 class="policy-wizard__step-title">Target asset</h2>
                  <p class="policy-wizard__step-desc">Select the dataset or model this policy will govern.</p>
                </div>

                <div class="add-policy-home__grid-2">
                  <div class="add-policy-home__field">
                    <label class="add-policy-home__label" for="add-policy-asset-kind">
                      Asset type<span class="add-policy-home__required" aria-hidden="true">*</span>
                    </label>
                    <app-multiselect
                      id="add-policy-asset-kind"
                      [ngModel]="assetKindSelection"
                      (ngModelChange)="onAssetKindMultiselectChange($event)"
                      [ngModelOptions]="{ standalone: true }"
                      [options]="assetKindOptions"
                      optionLabel="label"
                      placeholder="Choose asset type"
                      [maxSelected]="1"
                      display="chip"
                      [showClear]="true"
                      styleClass="add-policy-home__multiselect"
                      (onTriggerMousedown)="onMultiselectTriggerMousedown($event)"
                      (onOpen)="onMultiselectOpen()"
                    ></app-multiselect>
                  </div>
                  <div class="add-policy-home__field add-policy-home__asset-search">
                    <label class="add-policy-home__label" for="add-policy-asset-search">
                      {{ hasAssetKindSelected ? assetKindLabel : 'Asset' }}
                      <span class="add-policy-home__required" *ngIf="hasAssetKindSelected" aria-hidden="true">*</span>
                    </label>
                    <div class="add-policy-home__search-wrap">
                      <input
                        id="add-policy-asset-search"
                        type="text"
                        class="add-policy-home__input"
                        [(ngModel)]="assetSearchQuery"
                        [ngModelOptions]="{ standalone: true }"
                        (input)="onAssetSearchInput()"
                        (focus)="onAssetSearchFocus()"
                        [placeholder]="
                          hasAssetKindSelected ? ('Search ' + (assetKindLabel | lowercase) + '…') : 'Select asset type first'
                        "
                        [disabled]="!hasAssetKindSelected"
                        autocomplete="off"
                      />
                      <button
                        *ngIf="assetSearchQuery"
                        type="button"
                        class="add-policy-home__search-clear"
                        (click)="clearAssetSelection()"
                        aria-label="Clear selection"
                      >
                        ×
                      </button>
                      <div class="add-policy-home__autocomplete" *ngIf="showAssetAutocomplete && assetSuggestions.length > 0">
                        <button
                          type="button"
                          class="add-policy-home__autocomplete-item"
                          *ngFor="let suggestion of assetSuggestions"
                          (click)="selectAssetSuggestion(suggestion)"
                        >
                          <span class="add-policy-home__autocomplete-label">{{ suggestion.label }}</span>
                          <span class="add-policy-home__autocomplete-org" *ngIf="suggestion.organization">{{
                            suggestion.organization
                          }}</span>
                        </button>
                      </div>
                      <div
                        class="add-policy-home__autocomplete add-policy-home__autocomplete--loading"
                        *ngIf="
                          !assetsSearching &&
                          assetSearchAttempted &&
                          assetSuggestions.length === 0 &&
                          hasAssetKindSelected &&
                          assetSearchQuery.trim() &&
                          !form.get('selectedAssetId')?.value
                        "
                      >
                        No {{ assetKindLabel | lowercase }} found
                      </div>
                      <div class="add-policy-home__autocomplete add-policy-home__autocomplete--loading" *ngIf="assetsSearching">
                        Searching…
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <!-- Step 3 -->
              <div class="policy-wizard__step-panel" *ngIf="currentStep === 3">
                <div class="policy-wizard__step-intro">
                  <h2 class="policy-wizard__step-title">Access constraints</h2>
                  <p class="policy-wizard__step-desc">
                    Select at least one constraint<span class="add-policy-home__required" aria-hidden="true">*</span>.
                    Expiry date and time are required for each selected constraint.
                  </p>
                </div>

                <div class="add-policy-home__table-wrap">
                  <table class="add-policy-home__table">
                    <thead>
                      <tr>
                        <th scope="col" class="add-policy-home__th add-policy-home__th--check"></th>
                        <th scope="col" class="add-policy-home__th">Constraint</th>
                        <th scope="col" class="add-policy-home__th">
                          Expiry date<span class="add-policy-home__required" aria-hidden="true">*</span>
                        </th>
                        <th scope="col" class="add-policy-home__th">
                          Expiry time<span class="add-policy-home__required" aria-hidden="true">*</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let row of visibleConstraintRows"
                        class="add-policy-home__tr"
                        (click)="onConstraintRowClick($event, row)"
                      >
                        <td class="add-policy-home__td add-policy-home__td--check">
                          <input
                            type="checkbox"
                            [formControlName]="row.enabledKey"
                            [attr.aria-label]="'Enable ' + row.name + ' constraint'"
                            (click)="$event.stopPropagation()"
                            (change)="onConstraintToggle(row, $event)"
                          />
                        </td>
                        <td class="add-policy-home__td add-policy-home__td--name">
                          <span class="add-policy-home__constraint-name">{{ row.name }}</span>
                        </td>
                        <td class="add-policy-home__td add-policy-home__td--date">
                          <app-date-range-picker
                            [ngModel]="rowExpiryDateRangeModels[row.dateKey]"
                            (ngModelChange)="onRowExpiryDateChange(row, $event)"
                            [ngModelOptions]="{ standalone: true }"
                            [singleDateMode]="true"
                            [disableFutureDates]="false"
                            [minDate]="constraintExpiryMinDate"
                            [disabled]="isConstraintRowExpiryDisabled(row)"
                            placeholder="Select date"
                            styleClass="add-policy-home__date-picker add-policy-home__date-picker--cell"
                            (onOpen)="onDateRangePickerOpen()"
                          ></app-date-range-picker>
                        </td>
                        <td class="add-policy-home__td add-policy-home__td--time">
                          <app-time-picker
                            [formControlName]="row.timeKey"
                            [minuteStep]="5"
                            [minTime]="getConstraintRowMinTime(row)"
                            placeholder="Select time"
                            styleClass="add-policy-home__time-picker add-policy-home__time-picker--cell"
                            [attr.aria-label]="row.name + ' expiry time'"
                            (onOpen)="onConstraintTimePickerOpen(row)"
                          ></app-time-picker>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

              <!-- Step 4 -->
              <div class="policy-wizard__step-panel" *ngIf="currentStep === 4">
                <div class="policy-wizard__step-intro">
                  <h2 class="policy-wizard__step-title">Comments</h2>
                  <p class="policy-wizard__step-desc">Add internal notes and a comment for the requester.</p>
                </div>

                <div class="add-policy-home__grid-2">
                  <div class="add-policy-home__field">
                    <label class="add-policy-home__label" for="add-policy-provider-comment">
                      Notes<span class="add-policy-home__required" aria-hidden="true">*</span>
                    </label>
                    <textarea
                      id="add-policy-provider-comment"
                      class="add-policy-home__textarea"
                      formControlName="providerComment"
                      rows="4"
                      placeholder="Internal notes about this policy"
                    ></textarea>
                  </div>
                  <div class="add-policy-home__field">
                    <label class="add-policy-home__label" for="add-policy-feedback-comment">
                      Requester comment<span class="add-policy-home__required" aria-hidden="true">*</span>
                    </label>
                    <textarea
                      id="add-policy-feedback-comment"
                      class="add-policy-home__textarea"
                      formControlName="feedbackComment"
                      rows="4"
                      placeholder="Comment visible to the requester"
                    ></textarea>
                  </div>
                </div>

              </div>
              </div>

              <div class="policy-wizard__actions">
                <button
                  *ngIf="embedded && currentStep === 1"
                  type="button"
                  class="policy-wizard__btn policy-wizard__btn--secondary"
                  [disabled]="isSubmitting"
                  (click)="onWizardBackClick()"
                >
                  Cancel
                </button>
                <button
                  *ngIf="currentStep > 1"
                  type="button"
                  class="policy-wizard__btn policy-wizard__btn--secondary"
                  [disabled]="isSubmitting"
                  (click)="onWizardBackClick()"
                >
                  ← Previous
                </button>
                <button
                  *ngIf="currentStep < totalSteps"
                  type="button"
                  class="policy-wizard__btn policy-wizard__btn--primary"
                  [disabled]="isWizardPrimaryDisabled"
                  (click)="onWizardPrimaryClick($event)"
                >
                  {{ wizardPrimaryLabel }}
                </button>
                <button
                  *ngIf="currentStep === totalSteps"
                  type="submit"
                  class="policy-wizard__btn policy-wizard__btn--primary"
                  [disabled]="isSubmitting || isStepFourSubmitDisabled"
                >
                  <span *ngIf="!isSubmitting">{{ wizardPrimaryLabel }}</span>
                  <span *ngIf="isSubmitting">Saving…</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
